import React, {Component} from "react"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faExternalLinkAlt} from '@fortawesome/free-solid-svg-icons'
import {Row} from "react-bootstrap"
import ProviderSlider from "./ProviderSlider";
import Message from "./Message";
import TypingMessage from "./TypingMessage";
import CancelButton from "./CancelButton";
import Feedback from "./Feedback";
import {getTimeAMPMFormat, keydownHandler} from "../utils/commonHelper";
import {
    CONNECT_EVENT_CHAT_ENDED,
    CONNECT_EVENT_JOINED,
    CONNECT_EVENT_LEFT,
    CONTENT_TYPE_CAROUSEL,
    CONTENT_TYPE_EVENT,
    CONTENT_TYPE_FEEDBACK,
    CONTENT_TYPE_TEXT, CONTENT_TYPE_TRANSFER,
    CONTENT_TYPE_TYPING,
    MSG_CANCEL_LIVE_CHAT,
    MSG_WAITING_AGENT,
    ROLE_AGENT,
    ROLE_SYSTEM
} from "../utils/constants";
import {StartOverIcon} from "./Icons";
import {getBackToIntentHistoryMessage, updateLastIntentHistory} from "./IntentsHistory";

export default class Template extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ...props,
            buttonClicked: false,
            agentConnected: false,
            askNameValue: '',
        }
        this.state.init(this);
    }

    handleClick = (button) => {
        if (!this.state.isSafari) {
            this.setState({
                buttonClicked: !(button.newWindow || false)
            });
        }
        const {avatar} = this.props;
        this.props.onButtonClick(button.title, button.url, {avatar: avatar, button: button})
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        let {type, role, agentConnected} = this.state;
        if (type === CONNECT_EVENT_JOINED && role === ROLE_AGENT && agentConnected === false) {
            this.setState({
                agentConnected: true
            });
        }
    }

    changeAskNameValue = (e) => {
        this.setState({
            askNameValue: e.target.value
        });
    };

    renderMessage = (
        type,
        data,
        role,
        last,
        buttonClicked,
        dataKey,
        avatar,
        message,
        username,
        displayName,
        isLastInChain,
        isLastMessageForRole,
        agentConnected,
        showCancelButton,
        feedbackValue,
        showFeedback
    ) => {
        const {showRestartChat, prescription, cancelButtonTitle, currentQueueName, askName, askDOB, agents} = this.props;
        const chatEnded = agents[this.props.contactId] ? agents[this.props.contactId].chatEnded : "";
        switch (type) {
            case CONTENT_TYPE_CAROUSEL:
                return <ProviderSlider data={data}
                                       buttonClick={this.state.onButtonClick}
                                       role={role}
                                       last={last}
                                       buttonClicked={buttonClicked}
                                       scrollToBottom={this.state.scrollToBottom}
                />
            case CONTENT_TYPE_EVENT:
                return <>
                    <Message data={data} message={message} role={ROLE_SYSTEM} isLastInChain={isLastInChain}
                             avatar={avatar} dataKey={dataKey}/>
                    {
                        showCancelButton && last && role === ROLE_SYSTEM ?
                            <CancelButton title={cancelButtonTitle} cancelLiveChat={this.state.cancelLiveChat}
                                          agentConnected={agentConnected}/>
                            :
                            ""
                    }
                </>
            case CONNECT_EVENT_JOINED:
                if (role === ROLE_AGENT) {
                    if (((type === CONNECT_EVENT_JOINED && !this.state.showCancelButton) && role === ROLE_AGENT && document.getElementsByClassName('cancel-button')[0] !== undefined) || !showCancelButton) {
                        for (const s of document.getElementsByClassName("cancel-button")) {
                            s.style.display = "none";
                        }
                    }
                    let messageAgentConnected = 'You are now being connected to a live agent';
                    const hookGetMessageAgentConnected = ((this.props.config || {}).hooks || {}).getMessageAgentConnected;
                    if (hookGetMessageAgentConnected) {
                        messageAgentConnected = hookGetMessageAgentConnected();
                    }

                    let messageAfterAgentConnected = 'Hi, my name is ' + displayName + ', how can I help you?';
                    const prescriptionInfo = ((prescription || {}).additionalData || {}).prescription;
                    if (prescriptionInfo) {
                        messageAfterAgentConnected = 'Hi, my name is ' + displayName + '. Please allow me 2 minutes to review this request.';
                        if (prescriptionInfo.length) {
                            messageAfterAgentConnected = messageAfterAgentConnected + ' I will confirm when it is complete. If you disconnect before the request is confirmed it will be cancelled.';
                        }
                    }
                    const hookGetMessageAfterAgentConnected = ((this.props.config || {}).hooks || {}).getMessageAfterAgentConnected;
                    if (hookGetMessageAfterAgentConnected) {
                        messageAfterAgentConnected = hookGetMessageAfterAgentConnected(displayName, currentQueueName);
                    }

                    return <>
                        {
                            messageAgentConnected ?
                                <Message data={data} message={messageAgentConnected} role={ROLE_SYSTEM}
                                         isLastInChain={false}
                                         avatar={avatar} dataKey={dataKey}/>
                                :
                                ''
                        }
                        {
                            messageAfterAgentConnected ?
                                <Message data={data} message={messageAfterAgentConnected} role={role} isLastInChain={isLastInChain}
                                         avatar={avatar} dataKey={'ms_' + dataKey}/>
                                :
                                ''
                        }
                    </>
                }
                return <></>
            case CONNECT_EVENT_LEFT:
                if (username === displayName) {
                    let messageText = 'You ended conversation';

                    return <Message data={data} message={messageText} role={ROLE_SYSTEM} isLastInChain={isLastInChain}
                                    avatar={avatar} dataKey={dataKey}/>
                }
                return <></>
            case CONNECT_EVENT_CHAT_ENDED:
                try {
                    this.state.scrollToBottom();
                } catch (e) {
                }
                return <>
                    {
                        showRestartChat && last && !this.props.isStandalone ?
                            <Row className={"message-buttons visible"}>
                                <a className={"template__href btn_start_over"}
                                   tabIndex={0}
                                   onKeyDown={keydownHandler}
                                   onClick={this.state.restartChat}
                                >
                                    <div style={{display: "flex"}}>
                                        <StartOverIcon className="icon"/>
                                        <span>Start Over</span>
                                    </div>
                                </a>
                            </Row>
                            :
                            ''
                    }
                    {
                        this.props.chatEnded && !this.state.showTimeoutMessage ?
                            <div style={{height: "80px", position: "relative"}}>
                                <div className="chat_end_breaker">
                                    {message||'Chat ended ' + getTimeAMPMFormat(new Date())}
                                </div>
                            </div> : ''
                    }
                </>
            case CONTENT_TYPE_TYPING:
                try {
                    this.state.scrollToBottom();
                } catch (e) {
                }
                return <TypingMessage/>
            case CONTENT_TYPE_TEXT:
                return <>
                    {
                        ((data && !data.hidden) || (data === null)) &&
                        <Message data={data} message={message} role={role} isLastInChain={isLastInChain}
                                 isLastMessageForRole={isLastMessageForRole} sendMessage={this.props.sendMessage}
                                 key={dataKey} avatar={avatar}/>
                    }
                    {
                        role === ROLE_SYSTEM && last && !buttonClicked && !showCancelButton ?
                            <Row className={"message-buttons visible"}>
                                {
                                    data !== null && data.buttons && data.buttons.length && data.buttons.map((button, key) =>
                                        <React.Fragment key={key}>
                                            {
                                                (data.buttons.length > 1 && (
                                                    button.onNewLine
                                                    || (button.title === "Start Over" && !button.hasOwnProperty('onNewLine'))
                                                )) ? <br/> : ""
                                            }
                                            <a
                                                className={"template__href " + button.class}
                                                tabIndex={0}
                                                onKeyDown={keydownHandler}
                                                onClick={() => this.handleClick(button)}>
                                                {
                                                    (button.title === "Start Over") ?
                                                        <div style={{display: "flex"}}>
                                                            <StartOverIcon className="icon"/>
                                                            <span>{button.title}</span>
                                                        </div>
                                                        :
                                                        button.title
                                                }
                                                {button.url && <FontAwesomeIcon icon={faExternalLinkAlt}/>}
                                            </a>
                                        </React.Fragment>
                                    )
                                }
                            </Row>
                            :
                            ""
                    }
                    {
                        showCancelButton && last && role === ROLE_SYSTEM ?
                            <CancelButton title={cancelButtonTitle} cancelLiveChat={this.state.cancelLiveChat}
                                          agentConnected={agentConnected}/>
                            :
                            ""
                    }
                    {
                        askName && last ?
                            <div className="ask_name">
                                <div className="ask_name_field">
                                    <div>
                                        <div className="title">
                                            {
                                                askDOB ?
                                                    "Enter date of birth"
                                                    :
                                                    (data && data.title && data.title.toLowerCase().indexOf('and date of birth') !== -1) ?
                                                        "Enter Full Name and date of birth"
                                                        :
                                                        "Enter Full Name"
                                            }
                                        </div>
                                        <div style={{textAlign: "right"}}>
                                            <input ref={c => this.askNameInputBox = c}
                                                   value={this.state.askNameValue}
                                                   onChange={this.changeAskNameValue}
                                                   onKeyDown={(e) => {
                                                       if (e.key === 'Enter' || e.keyCode === 13) {
                                                           e.preventDefault();
                                                           this.props.sendMessage(this.state.askNameValue, null, true);
                                                       }
                                                   }}
                                            />
                                            {
                                                !this.props.isStandalone ?
                                                    <>
                                                        <br/>
                                                        <a className="cancel_button"
                                                           tabIndex={0}
                                                           onKeyDown={keydownHandler}
                                                           onClick={(e) => {
                                                            e.preventDefault();
                                                            if (e.currentTarget) {
                                                                if (e.currentTarget.disabled) {
                                                                    return;
                                                                }
                                                                e.currentTarget.disabled = true;
                                                            }
                                                            let message;
                                                            try {
                                                                message = getBackToIntentHistoryMessage();
                                                                if (!message) {
                                                                    //return;
                                                                    message = 'sys_back::Cancel'; // if history disabled and Live Chat canceled
                                                                } else {
                                                                    updateLastIntentHistory(null);
                                                                }
                                                            } catch (e) {
                                                                console.error(e)
                                                            }
                                                            this.props.sendMessage(message);
                                                        }}>
                                                            Cancel
                                                        </a>
                                                    </>
                                                    : ''
                                            }
                                            <button
                                                tabIndex={0}
                                                onKeyDown={keydownHandler}
                                                onClick={() => this.props.sendMessage(this.state.askNameValue, null, true)}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            ''
                    }
                </>
            case CONTENT_TYPE_FEEDBACK:
                try {
                    this.state.scrollToBottom();
                } catch (e) {
                }
                return <>
                    {
                        this.props.contactId && showFeedback?
                            <Feedback feedbackMessage={message}
                                      avatar={avatar}
                                      feedbackValue={feedbackValue}
                                      contactId={this.props.contactId}
                                      feedbackConfig={(this.props.config || {}).feedbackConfig}
                                      onUpdateFeedback={this.props.onUpdateFeedback}
                                      feedbackLoaderStatus={this.props.feedbackLoaderStatus}
                                      agents={this.props.agents}
                                      sendFeedback={this.props.sendFeedback}
                                      waitBeforeShow={500}
                                      showCancelFeedback={this.props.showCancelFeedback}
                            />
                            :
                            ""
                    }
                </>
            case CONTENT_TYPE_TRANSFER:
                return <div style={{height: "80px", position: "relative"}}>
                    <div className="chat_end_breaker">
                        {message}
                    </div>
                </div>
            default:
                return <></>
        }
    }

    render = () => {
        const {buttonClicked, agentConnected} = this.state;
        const {
            avatar,
            dataKey,
            username,
            displayName,
            last,
            showCancelButton,
            feedbackValue,
            showFeedback,
            isLastInChain,
            isLastMessageForRole
        } = this.props;

        let {type, message, role} = this.props;
        let data = null;
        try {
            data = JSON.parse(message)
            if (data.data) {
                data = data.data.content
            }
            if (data.type === CONTENT_TYPE_EVENT) {
                // Don't render *events from server
                return <></>;
            }
            if (data.type === CONTENT_TYPE_CAROUSEL) {
                type = CONTENT_TYPE_CAROUSEL;
            }
        } catch (e) {
        }

        if (message === MSG_CANCEL_LIVE_CHAT) {
            if (this.props.isStandalone) {
                const cancelLiveChatMessage = ((this.props.config || {}).messages || {}).cancelLiveChatMessage;
                data = cancelLiveChatMessage ?
                    cancelLiveChatMessage
                    :
                    {
                        title: "Live agent search has been cancelled."
                    };
                role = ROLE_SYSTEM;
                type = CONTENT_TYPE_TEXT;
            } else {
                message = 'Live agent search has been cancelled.';
                type = CONTENT_TYPE_EVENT;
            }
        }

        if (message === MSG_WAITING_AGENT) {
            let waitingAgentEventMessage = ((this.props.config || {}).messages || {}).waitingAgentEventMessage;
            const hookGetWaitingAgentEventMessage = ((this.props.config || {}).hooks || {}).getWaitingAgentEventMessage;
            if (hookGetWaitingAgentEventMessage) {
                waitingAgentEventMessage = hookGetWaitingAgentEventMessage(this.props);
            }
            message = (waitingAgentEventMessage) ?
                waitingAgentEventMessage
                :
                'We\'re sorry, all of our agents are currently serving customers, please try again in a few minutes.';
            type = CONTENT_TYPE_EVENT;
        }

        if (data !== null && data.title !== undefined && Array.isArray(data.title)) {
            return data.title.map((title, i) => {
                const complexLast = (data.title.length === i + 1) && last;
                return this.renderMessage(type, {}, role, complexLast, buttonClicked, dataKey + '_' + i, avatar, title, username,
                    displayName, data.title[i + 1] ? false : isLastInChain, isLastMessageForRole, agentConnected,
                    showCancelButton, feedbackValue, showFeedback
                );
            });
        } else {
            return this.renderMessage(type, data, role, last, buttonClicked, dataKey, avatar, message, username,
                displayName, isLastInChain, isLastMessageForRole, agentConnected, showCancelButton, feedbackValue, showFeedback
            );
        }
    }
}

